import { createPortal } from 'react-dom'
import { X } from 'lucide-react'
import Button from '../common/Button.js'
import { formatIstDateTime } from '../../utils/localDate.js'
import { formatAuditUserHubRole } from '../../utils/userDisplay.js'

const DeletedShipmentInfoModal = ({ shipment, onClose }) => {
  if (!shipment) return null

  const handleBackdrop = (event) => {
    if (event.target === event.currentTarget) onClose?.()
  }

  const who = formatAuditUserHubRole(shipment, 'deleted_by')
  const name = shipment.deleted_by_name || shipment.deleted_by_username || shipment.deleted_by || '—'
  const role = shipment.deleted_by_role || '—'
  const hub = shipment.deleted_by_location || '—'
  const when = formatIstDateTime(shipment.deleted_at) || '—'

  return createPortal(
    <div
      className="fixed inset-0 z-[95] bg-black/50 flex items-center justify-center p-4"
      onClick={handleBackdrop}
      role="dialog"
      aria-modal="true"
      aria-label="Deleted shipment details"
    >
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <h3 className="text-base font-semibold text-gray-900">Deleted shipment</h3>
          <Button variant="ghost" onClick={onClose} className="!p-1.5" aria-label="Close">
            <X className="w-5 h-5" />
          </Button>
        </div>
        <div className="px-4 py-4 space-y-3 text-sm">
          <p className="font-semibold text-gray-800 break-all">GC {shipment.shipment_id}</p>
          <div>
            <p className="text-xs font-medium text-gray-500 uppercase">Reason</p>
            <p className="mt-0.5 text-gray-900 whitespace-pre-wrap break-words">
              {shipment.delete_reason || '—'}
            </p>
          </div>
          <div className="grid grid-cols-1 gap-2">
            <div>
              <p className="text-xs font-medium text-gray-500 uppercase">Deleted by</p>
              <p className="mt-0.5 text-gray-900">{name}</p>
            </div>
            <div>
              <p className="text-xs font-medium text-gray-500 uppercase">Role</p>
              <p className="mt-0.5 text-gray-900">{role}</p>
            </div>
            <div>
              <p className="text-xs font-medium text-gray-500 uppercase">Location hub</p>
              <p className="mt-0.5 text-gray-900">{hub}</p>
            </div>
            <div>
              <p className="text-xs font-medium text-gray-500 uppercase">Date and time</p>
              <p className="mt-0.5 text-gray-900">{when}</p>
            </div>
          </div>
          {who && who !== '—' ? (
            <p className="text-xs text-gray-500">{who}</p>
          ) : null}
        </div>
      </div>
    </div>,
    document.body
  )
}

export default DeletedShipmentInfoModal
